import axios from "axios";
export const axiosInstance  = axios.create({
    baseURL : "https://isender.vercel.app/api/"
})